import React, {Component} from 'react'
import {Col, FormGroup, Row} from 'react-bootstrap'
import moment from 'moment'
import {getToday}from "../../utils/date"
import {ReactPikadayComponent} from "./DateField";

const parsePikaDate = (v) => {
	if (!v) {
		return null
	}
	if (v instanceof Date) {
		return moment(v).format('YYYY-MM-DD')
	}
	if (v.length > 10) {
		v = v.substring(0, 10)
	}
	return new Date(v)
}

export default class FormDateInterval extends Component {

	render() {

		const {
			values,
			name,
			label,
			onInputChange
		} = this.props;

		const dateFrom = {
			name: name + "From",
			value: parsePikaDate(values[name + "From"]),
			onChange: (v) => {
				onInputChange({name: name + "From", value: parsePikaDate(v)}, true)
			}
		};
		const dateTo = {
			name: name + "To",
			value: parsePikaDate(values[name + "To"]),
			onChange: (v) => {
				onInputChange({name: name + "To", value: parsePikaDate(v)}, true)
			}
		};
		const today = getToday();

		return (
			<FormGroup controlId={name} title={label + " od - do"}>
				<Row>
					<Col xs={6} className={"pikaday-wrapper"}>
						<ReactPikadayComponent
							ref="pikaFrom"
							i18n={{
								months: moment.localeData()._months,
								weekdays: moment.localeData()._weekdays,
								weekdaysShort: moment.localeData()._weekdaysShort
							}}
							firstDay={1}
							format="DD.MM.YYYY"
							className="form-control"
							value={dateFrom.value}
							placeholder={label + " od"}
							maxDate={dateTo.value || today}
							yearRange={100}
							{...dateFrom}
						/>
						{dateFrom.value ? <span className="Select-clear-zone pikaday-clear" title="Vymazat"  onClick={() => {
								this.refs.pikaFrom.pikaday.setDate(null);
								dateFrom.onChange(null)
							}}>
							<span className="Select-clear">×</span>
						</span> : null}
					</Col>
					<Col xs={6} className={"pikaday-wrapper"}>
						<ReactPikadayComponent
							ref="pikaTo"
							i18n={{
								months: moment.localeData()._months,
								weekdays: moment.localeData()._weekdays,
								weekdaysShort: moment.localeData()._weekdaysShort
							}}
							firstDay={1}
							format="DD.MM.YYYY"
							className="form-control"
							value={dateTo.value}
							placeholder={label + " do"}
							yearRange={100}
							minDate={dateFrom.value}
							maxDate={today}
							{...dateTo}
						/>
						{dateTo.value ? <span className="pikaday-clear" title="Vymazat" onClick={() => {
							this.refs.pikaTo.pikaday.setDate(null);
							dateTo.onChange(null)
						}}>
							<span className="pikaday-clear-cross">×</span>
						</span> : null}
					</Col>
				</Row>
			</FormGroup>
		);
	}
}
